var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-add-dialog" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formPower",
            attrs: {
              "label-position": "top",
              model: _vm.formPower,
              rules: _vm.roleRules,
              "label-width": "120px"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "键值对组名称", prop: "dictGroupName" } },
              [
                _c("el-input", {
                  staticClass: "limit256",
                  attrs: {
                    size: "small",
                    maxlength: "128",
                    "show-word-limit": "",
                    placeholder: "请输入键值对组名称"
                  },
                  model: {
                    value: _vm.formPower.dictGroupName,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formPower,
                        "dictGroupName",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formPower.dictGroupName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "键值对组键值", prop: "dictGroupCode" } },
              [
                _c("el-input", {
                  staticClass: "limit32",
                  attrs: {
                    size: "small",
                    maxlength: "32",
                    "show-word-limit": "",
                    placeholder: "请输入键值对组键值"
                  },
                  model: {
                    value: _vm.formPower.dictGroupCode,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.formPower,
                        "dictGroupCode",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formPower.dictGroupCode"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "子系统", prop: "systemId" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择子系统" },
                    on: {
                      change: function($event) {
                        return _vm.selectchangelist()
                      }
                    },
                    model: {
                      value: _vm.selectarr,
                      callback: function($$v) {
                        _vm.selectarr = $$v
                      },
                      expression: "selectarr"
                    }
                  },
                  _vm._l(_vm.systemlist, function(option) {
                    return _c("el-option", {
                      key: option.systemId,
                      attrs: {
                        label: option.systemName,
                        value: option.systemId
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "键值对组", prop: "relations" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      multiple: "",
                      placeholder: "请选择键值对组"
                    },
                    on: {
                      change: function($event) {
                        return _vm.selectchange()
                      }
                    },
                    model: {
                      value: _vm.formPower.relations,
                      callback: function($$v) {
                        _vm.$set(_vm.formPower, "relations", $$v)
                      },
                      expression: "formPower.relations"
                    }
                  },
                  _vm._l(_vm.dictarr, function(option) {
                    return _c("el-option", {
                      key: option.id,
                      attrs: { label: option.dictGroupName, value: option.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm.ifVirtualEdit
              ? _c(
                  "el-form-item",
                  { attrs: { label: "键值对组状态：" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          placeholder: "请选择键值对组状态"
                        },
                        model: {
                          value: _vm.formPower.groupStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.formPower, "groupStatus", $$v)
                          },
                          expression: "formPower.groupStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "有效", value: "VALID" }
                        }),
                        _c("el-option", {
                          attrs: { label: "失效", value: "INVALID" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c("input", {
          staticClass: "btn",
          attrs: { type: "button", value: "取消" },
          on: { click: _vm.cancelDailog }
        }),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title:
                _vm.ifVirtualEdit == "edit"
                  ? "确认修改此键值对组(虚拟)？"
                  : "确认添加此键值对组(虚拟)"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c("input", {
              staticClass: "btn btn-red",
              attrs: { slot: "reference", type: "button", value: "确认" },
              slot: "reference"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }